import { faEnvelope } from "@fortawesome/pro-regular-svg-icons/faEnvelope";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { FC } from "react";

export const Envelope: FC<JSX.IntrinsicAttributes> = (props) => {
  return <FontAwesomeIcon icon={faEnvelope} {...props} />;
};
